import { Button, Flex, Space, Tag } from 'antd'
import { take } from 'lodash'

import { filterTagGroupProps, FilterTagProps } from './interface'

const FilterTag = ({ data, maxCount = 4, onClose }: FilterTagProps) => {
  const text = take(data, maxCount).join('、')
  return (
    <Tag closable style={{ borderRadius: '2px' }} onClose={onClose}>
      {text}
      {data.length >= maxCount && <span>&nbsp;...&nbsp;</span>}
    </Tag>
  )
}

export const FilterTagGroup = ({
  groupMap,
  maxCount,
  extraContent,
  onClear,
  onReset
}: filterTagGroupProps) => {
  return (
    <Flex justify='space-between'>
      <Space size={4} wrap={false}>
        {Object.keys(groupMap).map(key => {
          const data = groupMap[key]
          return data?.length ? (
            <FilterTag
              key={key}
              data={data}
              maxCount={maxCount}
              onClose={() => {
                onClear(key)
              }}
            />
          ) : null
        })}
        {extraContent}
      </Space>
      <Button type='default' onClick={onReset}>
        清空条件
      </Button>
    </Flex>
  )
}
